import React from "react";

const R2RLogo = () => {
  return (
    <svg
      viewBox="0 0 395.5199999999999 160.66969713809394"
      height="3vh"
      width="100%"
    >
      <g>
        <svg
          viewBox="0 0 395.5199999999999 160.66969713809394"
          height="160.66969713809394"
          width="395.5199999999999"
        >
          <g>
            <svg
              viewBox="0 0 395.5199999999999 160.66969713809394"
              height="160.66969713809394"
              width="395.5199999999999"
            >
              <g id="textblocktransform">
                <svg
                  viewBox="0 0 395.5199999999999 160.66969713809394"
                  height="160.66969713809394"
                  width="395.5199999999999"
                  id="textblock"
                >
                  <g>
                    <svg
                      viewBox="0 0 395.5199999999999 160.66969713809394"
                      height="160.66969713809394"
                      width="395.5199999999999"
                    >
                      <g transform="matrix(1,0,0,1,0,0)">
                        <svg
                          width="395.5199999999999"
                          viewBox="3.880000114440918 -36.54999923706055 89.95999908447266 36.54999923706055"
                          height="160.66969713809394"
                          data-palette-color="#130912"
                        >
                          <path
                            d="M13.48-14.13L10.6-14.13 10.6 0 3.88 0 3.88-36.15 14.9-36.15Q18.6-36.15 21.24-35.39 23.88-34.63 25.56-33.25 27.25-31.88 28.04-29.96 28.83-28.05 28.83-25.75L28.83-25.75Q28.83-23.93 28.29-22.3 27.75-20.68 26.74-19.35 25.73-18.03 24.24-17.03 22.75-16.03 20.85-15.43L20.85-15.43Q22.13-14.7 23.05-13.35L23.05-13.35 32.1 0 26.05 0Q25.18 0 24.56-0.35 23.95-0.7 23.53-1.35L23.53-1.35 15.93-12.93Q15.5-13.58 14.99-13.85 14.48-14.13 13.48-14.13L13.48-14.13ZM10.6-30.95L10.6-18.95 14.8-18.95Q16.7-18.95 18.11-19.43 19.53-19.9 20.44-20.74 21.35-21.58 21.8-22.73 22.25-23.88 22.25-25.25L22.25-25.25Q22.25-28 20.44-29.48 18.63-30.95 14.9-30.95L14.9-30.95 10.6-30.95ZM47.8-36.55L47.8-36.55Q50.3-36.55 52.37-35.81 54.45-35.08 55.92-33.73 57.4-32.38 58.22-30.48 59.05-28.58 59.05-26.25L59.05-26.25Q59.05-24.25 58.46-22.55 57.87-20.85 56.89-19.3 55.9-17.75 54.57-16.3 53.25-14.85 51.8-13.35L51.8-13.35 43.65-5.03Q44.85-5.38 46-5.56 47.15-5.75 48.2-5.75L48.2-5.75 57.47-5.75Q58.47-5.75 59.06-5.19 59.65-4.63 59.65-3.7L59.65-3.7 59.65 0 34.85 0 34.85-2.05Q34.85-2.68 35.11-3.35 35.37-4.03 35.95-4.6L35.95-4.6 46.92-15.6Q48.3-17 49.39-18.28 50.47-19.55 51.21-20.8 51.95-22.05 52.34-23.34 52.72-24.63 52.72-26.05L52.72-26.05Q52.72-27.35 52.35-28.34 51.97-29.33 51.27-30 50.57-30.68 49.61-31.01 48.65-31.35 47.45-31.35L47.45-31.35Q45.22-31.35 43.79-30.23 42.35-29.1 41.77-27.2L41.77-27.2Q41.5-26.25 40.95-25.84 40.4-25.43 39.55-25.43L39.55-25.43Q39.17-25.43 38.72-25.5L38.72-25.5 35.47-26.08Q35.85-28.68 36.92-30.64 38-32.6 39.61-33.91 41.22-35.23 43.31-35.89 45.4-36.55 47.8-36.55ZM75.22-14.13L72.34-14.13 72.34 0 65.62 0 65.62-36.15 76.65-36.15Q80.34-36.15 82.98-35.39 85.62-34.63 87.31-33.25 89-31.88 89.78-29.96 90.57-28.05 90.57-25.75L90.57-25.75Q90.57-23.93 90.03-22.3 89.5-20.68 88.48-19.35 87.47-18.03 85.98-17.03 84.5-16.03 82.59-15.43L82.59-15.43Q83.87-14.7 84.8-13.35L84.8-13.35 93.84 0 87.8 0Q86.92 0 86.31-0.35 85.7-0.7 85.27-1.35L85.27-1.35 77.67-12.93Q77.25-13.58 76.73-13.85 76.22-14.13 75.22-14.13L75.22-14.13ZM72.34-30.95L72.34-18.95 76.55-18.95Q78.45-18.95 79.86-19.43 81.27-19.9 82.18-20.74 83.09-21.58 83.55-22.73 84-23.88 84-25.25L84-25.25Q84-28 82.18-29.48 80.37-30.95 76.65-30.95L76.65-30.95 72.34-30.95Z"
                            opacity="1"
                            transform="matrix(1,0,0,1,0,0)"
                            fill="#130912"
                            className="undefined-text-0"
                            data-fill-palette-color="primary"
                            id="text-0"
                          />
                        </svg>
                      </g>
                    </svg>
                  </g>
                </svg>
              </g>
            </svg>
          </g>
          <g />
        </svg>
      </g>
      <defs />
    </svg>
  );
};

export default R2RLogo;
